// extracted by mini-css-extract-plugin
export default {"main":"cHhdwhaHxu74UzViiqa4","shell":"Px05arEjCwVUicD9dAOG","shellMain":"BhYRoLitr3iYsIGiWqjs"};